export const initialState = {
	commands: [],
	path: "root@aditya:~$",
	alert: false,
};
